import { render } from "./nick-name.vue?vue&type=template&id=952fff58"
import script from "./nick-name.vue?vue&type=script&lang=js"
export * from "./nick-name.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__